import HttpClient from "libs/utils/HttpClient";
import qs from "qs";

class ConfigSmartServiceService {


  async getConfigSmartService(body) {
    try {
      const params = qs.stringify({
        ...(body && body.departmentId && { departmentId: body.departmentId }),
      });

      const response = await HttpClient.get(`/api/configsmartservice/list?${params}`);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }

  // async addHolidays(body) {
  //   try {
  //     const response = await HttpClient.post(`/api/holiday/add`, body);
  //     if (response.status) return response;
  //     return Promise.reject(response);
  //   } catch (error) {
  //     const newError = error;
  //     throw newError;
  //   }
  // }



  async addConfigSmartService(body) {
    try {
      const response = await HttpClient.post(`/api/configsmartservice/update`, body);
      if (response.status) return response;
      return Promise.reject(response);
    } catch (error) {
      const newError = error;
      throw newError;
    }
  }
}

export default new ConfigSmartServiceService();

